import { Button, Col, Form, Input, Row } from 'antd'
import qs from 'qs'
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { RouteChildrenProps } from "react-router"
import { PASSWORD_REGEX, SERVER_REDIRECT } from '../../../../constants/constants'
import { ROUTE_PATHS } from '../../../../constants/url-config'
import { LoginReq } from '../../../../models/auth/sign-in'
import { RegisterModel } from '../../../../models/auth/sign-up'
import { setUserInfoToAppState } from '../../../../redux/actions/user.action'
import { AuthService } from '../../../../services/auth.service'
import { InfoIcon } from "../../../atoms/icon"
import "./sign-up.scss"

interface Props extends RouteChildrenProps { }


const SignUp = (props: Props) => {

	const { t } = useTranslation();
	const [form] = Form.useForm();
	const [disabledEmail, setDisabledEmail] = useState(false);
	const dispatch = useDispatch();
	const redirect = useRef("");


	const handleSubmit = async (values: RegisterModel) => {
		await AuthService.register(values);
		const loginRq: LoginReq = {
			username: values.email,
			password: values.password

		}
		const res = await AuthService.loginAsync(loginRq);
		AuthService.setLoginData(res.data);
		await dispatch(setUserInfoToAppState());

		const redirectObj = SERVER_REDIRECT.find(x => x.key === redirect.current);

		if (redirectObj) {
			props.history.push(redirectObj?.value);
		} else if (redirect.current) {
			const url = atob(redirect.current);
			props.history.push(url);
		} else {
			props.history.push(ROUTE_PATHS.Home);
		}
	}

	const passwordExtra = () => {
		return (<div className='password-extra'>
			<InfoIcon />
			{t('SignUp.passwordDes')}
		</div>)
	}

	useEffect(() => {
		const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
		if (typeof (query.email) === "string") {
			form.setFieldsValue({ email: query.email });
			setDisabledEmail(true);
		}

		if (query.redirect) {
			redirect.current = query.redirect.toString();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="sign-up-form">
			<div className='header'>
				<p className='big-title'>
					{t('SignUp.title')}
				</p>
				<p className='description-text'>
					{t('SignUp.welcome')}
				</p>
			</div>
			<Form
				name='signin'
				layout="vertical"
				onFinish={handleSubmit}
				form={form}
			>
				<Row gutter={[16, 0]}>
					<Col span={12}>
						<Form.Item

							label={t('SignUp.firstName')}
							name='first_name'
							rules={[
								{ required: true, message: t('SignUp.firstNameRequired') }
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item
							label={t('SignUp.lastName')}
							name='last_name'
							rules={[
								{ required: true, message: t('SignUp.lastNameRequired') }
							]}
						>
							<Input />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label={t('SignUp.email')}
					name='email'
					rules={[
						{ required: true, message: t('SignUp.emailRequired') },
						{ type: 'email', message: t('SignUp.emailInvalid') },
					]}
				>
					<Input disabled={disabledEmail} />
				</Form.Item>


				<Form.Item
					label={t('SignUp.password')}
					name='password'
					extra={passwordExtra()}
					rules={[
						{ required: true, message: t('SignUp.passwordRequired') },
						() => ({
							validator(_, value) {
								var passwordReg = new RegExp(PASSWORD_REGEX);
								if (!value || passwordReg.test(value)) {
									return Promise.resolve();
								}
								return Promise.reject(t('SignUp.invalidPassword'));
							},
						})
					]}
				>
					<Input.Password
						iconRender={visible => (visible ? t('Global.hide') : t('Global.show'))}
					/>
				</Form.Item>

				<Form.Item
					label={t('SignUp.confirmPassword')}
					name='confirm_password'
					dependencies={['password']}
					rules={[
						{ required: true, message: t('SignUp.confirmPasswordRequired') },
						({ getFieldValue }) => ({
							validator(_, value) {
								if (!value || getFieldValue('password') === value) {
									return Promise.resolve();
								}
								return Promise.reject(t('SignUp.passwordsNotMatch'));
							},
						}),
					]}
				>
					<Input.Password
						iconRender={visible => (visible ? t('Global.hide') : t('Global.show'))}
					/>
				</Form.Item>

				<Row gutter={20} className='agree-text'>
					<Col span={24}>
						<span dangerouslySetInnerHTML={{ __html: t('SignUp.agreeText') }}>

						</span>
					</Col>
				</Row>

				<Form.Item>
					<Button htmlType='submit' type="primary" shape="round">
						{t('SignUp.continue')}
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}

export default SignUp;